module.exports = __webpack_public_path__ + "img/database-01.51218852.svg";